import { render, staticRenderFns } from "./employment-length.vue?vue&type=template&id=640e5c3f"
import script from "./employment-length.vue?vue&type=script&lang=js"
export * from "./employment-length.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports